/**
 * Phone-number normalization to +E.164.
 *
 * A cross-cutting pure helper shared by the backend (smsFollowup send/recovery,
 * staff SMS-number management) and the frontend. US-only product: a bare number
 * must be US-shaped (10 digits, or 11 with the leading 1) — anything else
 * returns null, so a malformed record-sourced phone (a 9-digit typo, a
 * leading-0 local format) drains as `no_phone` ("collect a phone") instead of
 * burning a send on an undialable number. An explicit leading + is deliberate
 * input and trusted as already-E.164.
 */
export function normalizeE164(input: string | null | undefined): string | null {
  const trimmed = (input ?? '').trim()
  if (!trimmed) return null

  if (trimmed.startsWith('+')) {
    const digits = trimmed.slice(1).replace(/\D/g, '')
    return digits.length >= 8 && digits.length <= 15 ? `+${digits}` : null
  }

  const digits = trimmed.replace(/\D/g, '')
  if (digits.length === 10) return `+1${digits}`
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`
  return null
}
